import React, { useContext } from "react"
import { Query } from "react-apollo"
import gql from "graphql-tag"
import FavoriteFile from "../components/FavoriteFile"
import { Link, Redirect } from "react-router-dom"
import AppContext from "../../../shared/AppContext"

export const searchFolder = gql`
  query searchFavorites($folderId: String, $keyword: String, $limit: Int) {
    viewer {
      id
      folders(id: $folderId) {
        id
        name
      }
    }
    searchFavorites(folderId: $folderId, keyword: $keyword, limit: $limit) {
      id
      name
      slug
      description
      favoriteType
      metadata {
        modelDisplayName
        bookmark
        searchKeyword
        vendor
        sector
        reportType
        reportId
        imageURL
      }
    }
  }
`

const FavoritesFolder = (props) => {
  const { folderId, searchKeyword, trackingLocation } = props
  const { trackEvent } = useContext(AppContext)

  const renderFolderFiles = (favorites, refetch) => {
    return (
      <>
        <div className="grid files-grid">
          {!favorites.length && !searchKeyword && (
            <div>No favorites added to this folder.</div>
          )}
          {!favorites.length && searchKeyword && <div>No search results.</div>}

          {favorites.map((favorite, idx) => {
            return (
              <FavoriteFile
                currentFolderId={folderId}
                key={idx}
                className="col"
                hasMenu={true}
                zIndex={0}
                favorite={favorite}
                refetchQuery={refetch}
                trackingLocation={trackingLocation}
              />
            )
          })}
        </div>
      </>
    )
  }

  let keyword = ""
  if (searchKeyword) keyword = searchKeyword

  return (
    <Query
      query={searchFolder}
      fetchPolicy="network-only"
      variables={{
        folderId,
        keyword,
      }}
    >
      {({ data, error, refetch }) => {
        if (error) return <div>Error while getting folder favorites.</div>
        if (
          data &&
          data.viewer &&
          data.viewer.folders &&
          !data.viewer.folders.length
        ) {
          return <Redirect to={"/404"} />
        }
        if (data && data.searchFavorites) {
          const folderName =
            data.viewer && data.viewer.folders && data.viewer.folders[0]
              ? data.viewer.folders[0].name
              : ""

          return (
            <>
              <div className={"section-title"}>
                <Link
                  className={"section-title"}
                  to="/favorites"
                  onClick={() => {
                    trackEvent("All Files link clicked", {
                      to: "/favorites",
                      location: trackingLocation,
                      folderName: folderName,
                    })
                  }}
                >
                  All Files
                </Link>
                <span>{` > ${folderName}`}</span>
              </div>
              <div>{renderFolderFiles(data.searchFavorites, refetch)}</div>
            </>
          )
        }

        return null
      }}
    </Query>
  )
}

export default FavoritesFolder
